var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditfaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7709_28673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9156 8.53064C12.547 8.53064 12.249 8.82935 12.249 9.19727V14.5306C12.249 14.8979 11.9503 15.1973 11.5824 15.1973H2.24902C1.88098 15.1973 1.5824 14.8979 1.5824 14.5306V5.19727C1.5824 4.82996 1.88098 4.53064 2.24902 4.53064H7.5824C7.95105 4.53064 8.24902 4.23193 8.24902 3.86401C8.24902 3.49597 7.95105 3.19727 7.5824 3.19727H2.24902C1.14636 3.19727 0.249023 4.0946 0.249023 5.19727V14.5306C0.249023 15.6333 1.14636 16.5306 2.24902 16.5306H11.5824C12.6851 16.5306 13.5824 15.6333 13.5824 14.5306V9.19727C13.5824 8.82861 13.2843 8.53064 12.9156 8.53064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49953 7.92334C6.4529 7.96997 6.42153 8.0293 6.40822 8.09326L5.93691 10.4507C5.91494 10.5599 5.9496 10.6726 6.02822 10.752C6.09157 10.8153 6.1769 10.8492 6.2643 10.8492C6.28554 10.8492 6.30764 10.8473 6.32961 10.8427L8.6863 10.3713C8.75161 10.3579 8.81093 10.3267 8.85695 10.2799L14.1316 5.00525L11.7749 2.64868L6.49953 7.92334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.761 1.01877C15.1111 0.368744 14.0537 0.368744 13.4043 1.01877L12.4817 1.94138L14.8384 4.29807L15.761 3.37534C16.0757 3.06137 16.249 2.64267 16.249 2.19736C16.249 1.75204 16.0757 1.33334 15.761 1.01877Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7709_28673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.249023 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditfaq);
export default __webpack_public_path__ + "static/media/editfaq.f9eb3c291d315ab79ea91c696d39ab45.svg";
export { ForwardRef as ReactComponent };